import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 172536 162133"
    {...props}
  >
    <path
      d="M150966 32729h-21506c0-3583-94-7447-94-11167C129366 9672 119745 0 107802 0H64683C52786 0 43116 9670 43116 21562v11167H21559C9675 32729 0 42398 0 54283v86296c0 11892 9675 21554 21559 21554h129407c11893 0 21570-9662 21570-21554V54283c-3-11885-9677-21554-21570-21554zm-32284 0H53900V21562c0-5902 4841-10778 10783-10778h43122c5942 0 10778 4876 10778 10778l99 11167zm-99 53948H97026V65117H75459v21560H53897v21559h21562v21562h21567v-21562h21557V86677z"
      style={{
        fill: "#262626",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
